<template>
  <div class="bod-message">
      <Header></Header>
      <div class="container">
          <div class="main_wrapper">
              <h1  data-aos="fade-up" class="gray" v-for="text in message.mainheading" :key="text">{{text}}</h1>
              <p v-for="text in message.Responsibilities" :key="text" data-aos="fade-up">{{text}}</p>
              <h3 class="gray" data-aos="fade-up" v-for="text in message.title1" :key="text">{{text}}</h3>
              <p v-for="text in message.contents" :key="text" data-aos="fade-up">{{text}}</p>
              <h3 class="gray" data-aos="fade-up" v-for="text in message.title2" :key="text">{{text}}</h3>
              <p v-for="text in message.value" :key="text" data-aos="fade-up">{{text}}</p>
              <h3 class="gray" data-aos="fade-up" v-for="text in message.title3" :key="text">{{text}}</h3>
              <p v-for="text in message.opportunities" :key="text" data-aos="fade-up">{{text}}</p>
              <h3 class="gray" data-aos="fade-up" v-for="text in message.title4" :key="text">{{text}}</h3>
              <p v-for="text in message.business" :key="text" data-aos="fade-up">{{text}}</p>
              <h3 class="gray" data-aos="fade-up" v-for="text in message.title5" :key="text">{{text}}</h3>
              <p v-for="text in message.compliance" :key="text" data-aos="fade-up">{{text}}</p>
              <h3 class="gray" data-aos="fade-up" v-for="text in message.title6" :key="text">{{text}}</h3>
              <p v-for="text in message.place" :key="text" data-aos="fade-up">{{text}}</p>
              <h3 class="gray" data-aos="fade-up" v-for="text in message.title7" :key="text">{{text}}</h3>
              <p v-for="text in message.appreciation" :key="text" data-aos="fade-up">{{text}}</p>
              <p class="black mt-30" data-aos="fade-up" v-for="text in message.textend" :key="text"><strong>{{text}}</strong></p>
          </div>
      </div>
  </div>
</template>

<script>
import message from "@/components/strategy/json/BODmessage.json";
export default {
    components:{
        // sctionsScroll
    },
    data(){
        return{
            message:message,
        }
    },
     created(){
        this.$i18n.locale=="en" ? 
        this.message = this.message.en :
        this.message = this.message.ar;
    }
}
</script>
<style lang="scss">
    [data-page="BOD-message"]{
        .verticalLabel{
            color:#707070;
        }
    }
</style>
<style lang="scss" scoped>
/deep/{
    
    header{
        .menu {
            a{
                color:#000;
            }
            svg{
                fill:#000;
            }
        }
    }
}
.bod-message{
    overflow:hidden;
    padding-bottom:rem(100px);
    position:relative;
    &:after{
        content:"";
        position:absolute;
        width:100%;
        height:100%;
        background: url("../assets/images/banners/BOD-message-banner.jpg") left top no-repeat;
        background-size: cover;
        background-attachment: fixed;
        left:0;
        top:0;
        z-index:-1;
        @media screen  and (max-width:991px){
            background: url("../assets/images/banners/BOD-message-banner-responsive.jpg") left top no-repeat;
        }
        @media screen and (max-width:767px){
            background-position-x: 50%;
        }
    }
    .black{
        color:#707070 !important;
    }
    .main_wrapper{
        margin-top: rem(100px);
    }
    h1 {
        font-size: rem(45px);
        font-weight: 900;
        margin-bottom:rem(40px);
        @media screen and (max-width:767px){
            font-size: rem(35px);
            margin-bottom:rem(20px);
        }
        @media screen and (max-width:575px){
            font-size: rem(30px);
        }
    }
    h3{
        font-size: rem(35px);
        font-weight: 900;
        margin:rem(35px) 0 rem(10px) 0;
        line-height:1;
        @media screen and (max-width:767px){
            font-size: rem(25px);
            margin:rem(30px) 0 rem(10px) 0;
        }
        @media screen and (max-width:575px){
            font-size: rem(23px);
        }
    }

    
    p{
        font-size: rem(18px);
        font-weight: 600;
        color: #707070;
        line-height: 1.3;
        @media screen and (max-width:767px){
            font-size:rem(15px);
        }
    }
    .black{
        color: #000;
    }
    .gray{
        color: #707070;
    }
    .bold{
        font-size: rem(18px);
        font-weight: 700;
        line-height: 1.3;
        @media screen and (max-width:767px){
            font-size:rem(15px);
        }
    }
}
.ar {
   .bod-message{
        &:after{
            transform:scaleX(-1);
            @media screen and (max-width:767px){
                background-position-x: 50%;
            }
        }
        p{
            line-height:1.4;
        }
    
    } 
}
    


</style>